import script from "./CollectIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./CollectIndex.vue?vue&type=script&setup=true&lang=js"

import "./CollectIndex.vue?vue&type=style&index=0&id=53e60e02&lang=scss&scoped=true"

import exportComponent from "/var/www/ddup_czb/slczb_app_web/view/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53e60e02"]])

export default __exports__